//before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { DeleteUserAction, UpdateClientAction } from '../Redux/Actions/UsersAction';
// import {
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogTitle,
//   IconButton,
//   Tooltip,
//   CircularProgress,
//   Box,
// } from '@mui/material';
// import { Notify } from '../Utility/Notify';
// import { Link } from 'react-router-dom';
// import DeleteIcon from '@mui/icons-material/Delete';
// import CancelIcon from '@mui/icons-material/Cancel';
// import { useTheme } from '@mui/material/styles';
// import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
// import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
// import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
// import { Get_All_Leads_Preview_Action } from '../Redux/Actions/MarketingReports_Action';
// import { PreviewLeadModal } from '../Pages/PreviewLeadModal';

// export const ClientTable2 = ({ user, allusers }) => {
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const dispatch = useDispatch();

//   // Modal states
//   const [showPreview, setShowPreview] = useState(false);
//   const [previewLoading, setPreviewLoading] = useState(false);

//   // delete user state
//   const [showdelete, setShowdelete] = useState(false);
//   const [deleteLoading, setDeleteLoading] = useState(false);

//   // جلب بيانات الـ lead للمعاينة
//   const resLeadPreview = useSelector((state) => state.AllMarketingReports.LeadPreview);
//   const lead = resLeadPreview?.data;

//   const handlePreview = async () => {
//     setPreviewLoading(true);
//     setShowPreview(true);
//     await dispatch(Get_All_Leads_Preview_Action(user._id));
//     setPreviewLoading(false);
//   };

//   const handleClosePreview = () => {
//     setShowPreview(false);
//   };

//   const handleShowdelete = () => setShowdelete(true);
//   const handleClosedelete = () => setShowdelete(false);

//   const deleteuser = async () => {
//     setDeleteLoading(true);
//     await dispatch(
//       UpdateClientAction(user?._id, {
//         leadisactive: 'false',
//       }),
//     );
//     Notify('success', 'Leads Returned successfully', 'success');
//     allusers();
//     handleClosedelete();
//     setDeleteLoading(false);
//   };

//   return (
//     <div style={{ paddingBottom: '20px' }}>
//       {/* Preview Modal */}
//       <PreviewLeadModal
//         show={showPreview}
//         onHide={handleClosePreview}
//         lead={lead}
//         loading={previewLoading}
//       />

//       {/* Delete Modal - Material UI */}
//       <Dialog
//         open={showdelete}
//         onClose={handleClosedelete}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//           },
//         }}
//       >
//         <DialogTitle
//           sx={{
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//           }}
//         >
//           Delete This Client
//         </DialogTitle>
//         <DialogContent
//           sx={{
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//             padding: '20px',
//           }}
//         >
//           Are you sure you want to delete this client?
//         </DialogContent>
//         <DialogActions
//           sx={{
//             color: mode === 'dark' ? '#90caf9' : '#666',
//             backgroundColor: mode === 'dark' ? '#252525' : '#f5f5f5',
//           }}
//         >
//           <Button
//             onClick={handleClosedelete}
//             variant="outlined"
//             sx={{
//               background: '#fff',
//               color: '#102dff',
//               border: '2px solid #102dff',
//               '&:hover': {
//                 background: '#f8f9fa',
//                 border: '2px solid #102dff',
//               },
//             }}
//             startIcon={<CancelIcon />}
//           >
//             Close
//           </Button>
//           <Button
//             onClick={deleteuser}
//             variant="contained"
//             disabled={deleteLoading}
//             sx={{
//               background: '#102dff',
//               color: '#fff',
//               '&:hover': {
//                 background: '#0d25cc',
//               },
//             }}
//             startIcon={deleteLoading ? <CircularProgress size={16} /> : <DeleteIcon />}
//           >
//             {deleteLoading ? 'Deleting...' : 'Yes, I am Sure.'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Action Icons */}
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//         {/* Update Button */}
//         <Tooltip title="Edit Lead">
//           <IconButton
//             size="small"
//             component={Link}
//             to={`/updateclient/${user._id}`}
//             sx={{
//               color: mode === 'dark' ? 'white' : '#666',
//               '&:hover': {
//                 color: '#1976d2',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(25, 118, 210, 0.1)' : 'rgba(25, 118, 210, 0.1)',
//               },
//               textDecoration: 'none',
//             }}
//           >
//             <ModeEditOutlineOutlinedIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>

//         {/* Delete Button */}
//         {/* <Tooltip title="Delete Lead">
//                     <IconButton
//                         size="small"
//                         onClick={handleShowdelete}
//                         sx={{
//                             color: mode === "dark" ? "white" : '#666',
//                             '&:hover': {
//                                 color: '#d32f2f',
//                                 backgroundColor: mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.1)',
//                             }
//                         }}
//                     >
//                         <DeleteOutlineOutlinedIcon fontSize="small" />
//                     </IconButton>
//                 </Tooltip> */}

//         {/* Delete Button */}
//         {!window.location.hash.includes('AllLeadsnotactivated') && (
//           <Tooltip title="Delete Lead">
//             <IconButton
//               size="small"
//               onClick={handleShowdelete}
//               sx={{
//                 color: mode === 'dark' ? 'white' : '#666',
//                 '&:hover': {
//                   color: '#d32f2f',
//                   backgroundColor:
//                     mode === 'dark' ? 'rgba(211, 47, 47, 0.1)' : 'rgba(211, 47, 47, 0.1)',
//                 },
//               }}
//             >
//               <DeleteOutlineOutlinedIcon fontSize="small" />
//             </IconButton>
//           </Tooltip>
//         )}

//         {/* Preview Button */}
//         <Tooltip title="Preview Lead">
//           <IconButton
//             size="small"
//             onClick={handlePreview}
//             sx={{
//               color: mode === 'dark' ? 'white' : '#666',
//               '&:hover': {
//                 color: '#9c27b0',
//                 backgroundColor:
//                   mode === 'dark' ? 'rgba(156, 39, 176, 0.1)' : 'rgba(156, 39, 176, 0.1)',
//               },
//             }}
//           >
//             <RemoveRedEyeOutlinedIcon fontSize="small" />
//           </IconButton>
//         </Tooltip>
//       </Box>
//     </div>
//   );
// };


















// 20-5-2026
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UpdateClientAction } from '../Redux/Actions/UsersAction';
import {
  Button, Dialog, IconButton, Tooltip, CircularProgress, Box, Typography,
} from '@mui/material';
import { Notify }                    from '../Utility/Notify';
import { Link }                      from 'react-router-dom';
import DeleteIcon                    from '@mui/icons-material/Delete';
import CancelIcon                    from '@mui/icons-material/Cancel';
import DeleteOutlineOutlinedIcon     from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon   from '@mui/icons-material/ModeEditOutlineOutlined';
import RemoveRedEyeOutlinedIcon      from '@mui/icons-material/RemoveRedEyeOutlined';
import { Get_All_Leads_Preview_Action } from '../Redux/Actions/MarketingReports_Action';
import { PreviewLeadModal }          from '../Pages/PreviewLeadModal';

const C = {
  accent:     '#0D47A1',
  accentDark: '#0D47A1',
  accentSoft: 'rgba(26,62,207,0.07)',
  text:       '#1C2340',
  textMuted:  '#7B829A',
  border:     '#E8EAF0',
  white:      '#FFFFFF',
  danger:     '#F04438',
  dangerSoft: 'rgba(240,68,56,0.08)',
  success:    '#12B76A',
  warning:    '#F79009',
};

/*
 * showPreview / setShowPreview / showDelete / setShowDelete
 * بتيجي من ActionsMenu برة المنيو عشان الـ Dialog
 * ميتشالش من الـ DOM لما المنيو يقفل
 */
export const ClientTable2 = ({
  user,
  allusers,
  showPreview,
  setShowPreview,
  showDelete,
  setShowDelete,
}) => {
  const dispatch = useDispatch();

  const [previewLoading, setPreviewLoading] = useState(false);
  const [deleteLoading,  setDeleteLoading]  = useState(false);

  const resLeadPreview = useSelector(s => s.AllMarketingReports.LeadPreview);
  const lead = resLeadPreview?.data;

  /* ── جيب بيانات الـ preview لما الـ modal يتفتح ── */
  useEffect(() => {
    if (showPreview) {
      setPreviewLoading(true);
      dispatch(Get_All_Leads_Preview_Action(user._id))
        .finally(() => setPreviewLoading(false));
    }
  }, [showPreview]);

  /* ── Confirm delete ── */
  const deleteUser = async () => {
    setDeleteLoading(true);
    await dispatch(UpdateClientAction(user?._id, { leadisactive: 'false' }));
    Notify('success', 'Lead deleted successfully', 'success');
    allusers();
    setShowDelete(false);
    setDeleteLoading(false);
  };

  const isTrashPage = window.location.hash.includes('AllLeadsnotactivated');

  const iconBtnBase = {
    width: 28, height: 28,
    borderRadius: '8px',
    border: '0.5px solid transparent',
    color: C.textMuted,
    transition: 'all 0.15s ease',
  };

  return (
    <>
      {/* ── Preview Modal ── */}
      <PreviewLeadModal
        show={showPreview}
        onHide={() => setShowPreview(false)}
        lead={lead}
        loading={previewLoading}
      />

      {/* ── Delete Dialog ── */}
      <Dialog
        open={showDelete}
        onClose={() => setShowDelete(false)}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '14px',
            border: `1px solid ${C.border}`,
            boxShadow: '0 8px 32px rgba(16,24,40,0.12)',
            overflow: 'hidden',
          },
        }}
      >
        <Box sx={{ px: 3, pt: 2.5, pb: 1.5, borderBottom: `1px solid ${C.border}` }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box sx={{
              width: 40, height: 40, borderRadius: '10px',
              bgcolor: C.dangerSoft,
              display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
            }}>
              <DeleteOutlineOutlinedIcon sx={{ color: C.danger, fontSize: '20px' }} />
            </Box>
            <Box>
              <Typography sx={{ fontWeight: 700, fontSize: '15px', color: C.text, fontFamily: "'DM Sans', sans-serif" }}>
                Delete Lead
              </Typography>
              <Typography sx={{ fontSize: '12.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif" }}>
                This action cannot be undone
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box sx={{ px: 3, py: 2 }}>
          <Typography sx={{ fontSize: '13.5px', color: C.textMuted, fontFamily: "'DM Sans', sans-serif", lineHeight: 1.6 }}>
            Are you sure you want to delete{' '}
            <Box component="span" sx={{ fontWeight: 700, color: C.text }}>
              {user?.name || 'this lead'}
            </Box>
            ? The lead will be moved to trash.
          </Typography>
        </Box>

        <Box sx={{ px: 3, pb: 2.5, display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
          <Button
            onClick={() => setShowDelete(false)}
            variant="outlined"
            sx={{
              borderColor: C.border, color: C.textMuted,
              borderRadius: '8px', textTransform: 'none',
              fontFamily: "'DM Sans', sans-serif", fontWeight: 600, px: 2.5,
              '&:hover': { borderColor: C.accent, color: C.accent, bgcolor: C.accentSoft },
            }}
            startIcon={<CancelIcon sx={{ fontSize: '16px' }} />}
          >
            Cancel
          </Button>
          <Button
            onClick={deleteUser}
            variant="contained"
            disabled={deleteLoading}
            sx={{
              bgcolor: C.danger, color: '#fff',
              borderRadius: '8px', textTransform: 'none',
              fontFamily: "'DM Sans', sans-serif", fontWeight: 600, px: 2.5,
              boxShadow: 'none',
              '&:hover': { bgcolor: '#C0392B', boxShadow: 'none' },
              '&.Mui-disabled': { bgcolor: 'rgba(240,68,56,0.4)', color: '#fff' },
            }}
            startIcon={deleteLoading
              ? <CircularProgress size={14} sx={{ color: '#fff' }} />
              : <DeleteIcon sx={{ fontSize: '16px' }} />
            }
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </Box>
      </Dialog>

      {/* ── Action Icons ── */}
      {/* <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}>

        <Tooltip title="Edit Lead" placement="top">
          <IconButton
            size="small"
            component={Link}
            to={`/updateclient/${user._id}`}
            sx={{
              ...iconBtnBase,
              '&:hover': { color: C.accent, bgcolor: C.accentSoft, borderColor: 'rgba(26,62,207,0.25)' },
            }}
          >
            <ModeEditOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
          </IconButton>
        </Tooltip>

        <Tooltip title="Preview Lead" placement="top">
          <IconButton
            size="small"
            onClick={() => setShowPreview(true)}
            sx={{
              ...iconBtnBase,
              '&:hover': { color: '#7F77DD', bgcolor: 'rgba(127,119,221,0.08)', borderColor: 'rgba(127,119,221,0.3)' },
            }}
          >
            <RemoveRedEyeOutlinedIcon sx={{ fontSize: '16px' }} />
          </IconButton>
        </Tooltip>

        {!isTrashPage && (
          <Tooltip title="Delete Lead" placement="top">
            <IconButton
              size="small"
              onClick={() => setShowDelete(true)}
              sx={{
                ...iconBtnBase,
                '&:hover': { color: C.danger, bgcolor: C.dangerSoft, borderColor: 'rgba(240,68,56,0.25)' },
              }}
            >
              <DeleteOutlineOutlinedIcon sx={{ fontSize: '16px' }} />
            </IconButton>
          </Tooltip>
        )}

      </Box> */}
    </>
  );
};
